import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when an office clicks the active "Next" button on the
 * "Select Dates" step of the NEW Shift Request flow
 * Event: dental_portal:shift_request:dates_selected
 */
export function fireDatesSelected(): void {
  PosthogService.getInstance().track('dental_portal:shift_request:dates_selected');
}
